var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513.1V341.994H0V-0.00585938Z",
    fill: "#10338C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9 -0.00585938H441.9V341.994",
    fill: "#F6C500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9 21.0941L40.3 6.19414L60.9 20.9941L54 -0.00585938H26.7L19.9 21.0941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3001 25.4942L84.4001 1.29419L76.6 25.4942H51.3L71.8001 40.2942L64 64.2942L84.4001 49.4942L105 64.2942L97.1 40.2942L117.6 25.3942L92.3001 25.4942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3 69.1941L128.5 45.1941L120.7 69.1941H95.5L115.9 84.0941L108.1 108.094L128.5 93.2941L149.1 108.094L141.3 84.0941L161.7 69.1941H136.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.4 112.294L171.6 88.1941L163.8 112.294H138.5L159 127.194L151.2 151.194L171.6 136.394L192.2 151.194L184.3 127.194L204.8 112.194L179.4 112.294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.5 155.294L214.7 131.294L206.9 155.294H181.5L202.1 170.294L194.3 194.294L214.7 179.394L235.1 194.294L227.3 170.294L247.9 155.294H222.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.6 198.394L257.8 174.394L250 198.394H224.6L245.2 213.294L237.4 237.394L257.8 222.494L278.2 237.394L270.4 213.194L290.9 198.394H265.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.7 241.494L300.8 217.494L293 241.494H267.7L288.2 256.294L280.3 280.494L300.9 265.594L321.3 280.394L313.5 256.294L334 241.494H308.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.7 284.594L343.9 260.394L336.1 284.594H310.8L331.2 299.394L323.4 323.494L343.9 308.594L364.4 323.494L356.6 299.394L377 284.594H351.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387 303.494L379.1 327.594L353.8 327.694L373.6 341.994H400.2L420.1 327.594H394.8L387 303.494Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBa);
export default __webpack_public_path__ + "static/media/BA.2d3f1f692a2341ee428a30d88f779c53.svg";
export { ForwardRef as ReactComponent };